import { Box, CardMedia, Typography } from '@mui/material';
import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import './TimeLine.css';

const TimelineTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.white,
        color: '#1B1B1B',
        boxShadow: '-2px 2px 8px rgba(229, 228, 255, 0.83)',
        fontFamily: 'poppins',
        fontSize: '14px',
        padding: '12px',
    },
}));

const NextArrow1 = ({ onClick }) => {
    return (
        <Box sx={{ py: { xs: .5, sm: .7, md: 1 } }} className="arrow next1" onClick={onClick}>
            <i className='fas fa-angle-right'></i>
        </Box>
    );
};

const PrevArrow1 = ({ onClick }) => {
    return (
        <Box sx={{ py: { xs: .5, sm: .7, md: 1 } }} className="arrow prev1" onClick={onClick}>
            <i style={{ fontSize: '20px', paddingRight: '10px' }} className='fas fa-angle-left'></i>
        </Box>
    );
};
const NextArrow2 = ({ onClick }) => {
    return (
        <Box sx={{ py: { xs: .5, sm: .7, md: 1 } }} className="arrow next2" onClick={onClick}>
            <i style={{ fontSize: '20px', paddingLeft: '10px' }} className='fas fa-angle-right'></i>
        </Box>
    );
};

const PrevArrow2 = ({ onClick }) => {
    return (
        <Box sx={{ py: { xs: .5, sm: .7, md: 1 } }} className="arrow prev2" onClick={onClick}>
            <i className='fas fa-angle-left'></i>
        </Box>
    );
};


const TimeLine = () => {

    var settings1 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        autoplay: true,
        lazyLoad: true,
        rtl: true,
        nextArrow: <NextArrow1 />,
        prevArrow: <PrevArrow1 />
    }

    var settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        autoplay: true,
        lazyLoad: true,
        nextArrow: <NextArrow2 />,
        prevArrow: <PrevArrow2 />
    }

    return (
        <div>
            <Box sx={{ display: 'flex', alignItems: 'center', py: '20px' }}>
                <Box className="first-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#4741E4' }}></Box>
                <Box className="second-box" sx={{ height: { xs: '30px', sm: '40px', md: '50px', lg: '61px' }, width: { xs: '9px', sm: '12px', md: '15px', lg: '21px' }, background: '#7E89FF' }}></Box>
                <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { xs: '20px', sm: '22px', md: '25px', lg: '30px' }, lineHeight: { xs: '30px', lg: '45px' }, color: '#383838', textAlign: 'left', pl: { xs: '18px', sm: '22px', md: '28px', lg: '36px' } }}>
                    What’s Our <span style={{ fontWeight: 700, color: '#433ED1' }}>Timeline</span>
                </Typography>
            </Box>

            <Box sx={{ my: '50px', px: { xl: '70px' } }}>
                <Slider {...settings1} style={{ borderBottom: '2px dashed #BDC3FF4D' }}>
                    {/* top first tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>5th December 2020</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* top second tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>10th March 2020</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* top third tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>20th Sept 2020</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* top fourth tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>22nd December 2019</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Slider>
                <Slider {...settings2}>
                    {/* bottom first tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>5th December 2020</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* bottom second tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>10th March 2020</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* bottom third tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>20th Sept 2020</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    {/* bottom fourth tooltip */}
                    <Box>
                        <Box sx={{ m: { sm: '10px', md: '20px', xl: '35px' } }}>
                            <Box sx={{ p: { xs: '15px', sm: '12px', md: '20px', xl: '40px' }, background: '#FFFFFF', display: 'flex', alignItems: 'center' }}>
                                <TimelineTooltip title="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim viverra cras porta erat." placement="top-end">
                                    <CardMedia
                                        className='tooltip-hover'
                                        component="img"
                                        sx={{ width: { sm: '26px', md: '32px', lg: '40px' }, mr: '10px', p: { sm: '10px', md: '20px', lg: '30px' }, borderRadius: '50%', background: '#EEEFFF' }}
                                        image="https://i.ibb.co/8dBKgsn/timeline.png"
                                        alt="logo"
                                    />
                                </TimelineTooltip>
                                <Box sx={{ pl: '10px' }}>
                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 500, fontSize: { sm: '16px', md: '18px', lg: '20px' }, lineHeight: { sm: '26px', md: '30px' }, textAlign: 'left', color: '#433ED1' }}>Milestone Title</Typography>

                                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 300, fontSize: { sm: '12px', md: '14px', lg: '16px' }, lineHeight: { sm: '20px', md: '22px', lg: '24px' }, textAlign: 'left', color: '#383838', pt: { lg: '10px' } }}>22nd December 2019</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Slider>
            </Box>
        </div>
    );
};

export default TimeLine;